import axios from 'axios'

export default axios.create({
  baseURL: process.env.VUE_APP_MAGENTO + '/api'
  /* headers: {
    'Authorization': process.env.VUE_APP_AUTH
  } */
})
